import { Component, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Component({
    template: ''
})
export abstract class BasicComponent implements OnDestroy {
    public subscriptions: Subscription = new Subscription();
    public componentDestroyed$ = new Subject<void>();

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
